import successHandler from "../../handlers/successHandler";
import errorHandler from "../../handlers/errorHandler";
import { infractionService } from "../../services/infraction.service";
import infractionType from "./infractionTypes";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

/**
 * Get all infractions
 **/

export const getAllInfractionsAction = (page) => async (dispatch) => {
  try {
    dispatch({ type: infractionType["LOADING_INFRACTIONS"], payLoad: true });
    const response = await infractionService.getAllInfractions(page);
    dispatch({ type: infractionType["LOADING_INFRACTIONS"], payLoad: false });
    dispatch({ type: infractionType["ALL_INFRACTIONS"], payLoad: response });
  } catch (error) {
    dispatch({ type: infractionType["LOADING_INFRACTIONS"], payLoad: false });
    errorHandler(error, true);
  }
};

export const filterInfractionsAction = (payLoad, page) => async (dispatch) => {
  try {
    dispatch({ type: infractionType["FILTERING_INFRACTIONS"], payLoad: true });
    const response = await infractionService.filterInfractions(payLoad, page);
    dispatch({ type: infractionType["FILTERING_INFRACTIONS"], payLoad: false });
    dispatch({ type: infractionType["FILTER_INFRACTIONS"], payLoad: response });
    // successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: infractionType["FILTERING_INFRACTIONS"], payLoad: false });
  }
};

export const storeInfractionAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: infractionType["LOADING_INFRACTIONS"], payLoad: true });
    const response = await infractionService.storeInfraction(payLoad);
    dispatch({ type: infractionType["LOADING_INFRACTIONS"], payLoad: false });
    dispatch({ type: infractionType["STORE_INFRACTION"], payLoad: response });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: infractionType["LOADING_INFRACTIONS"], payLoad: false });
    errorHandler(error, true);
  }
};

export const searchInfractionsAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: infractionType["SEARCHING"], payLoad: true });
    const response = await infractionService.searchInfractions(payLoad);
    dispatch({ type: infractionType["SEARCHING"], payLoad: false });
    dispatch({ type: infractionType["SEARCH_INFRACTIONS"], payLoad: response });
    return response;
  } catch (error) {
    dispatch({ type: infractionType["SEARCHING"], payLoad: false });
  }
};

/**
 * Get an infraction
 **/

export const getAnInfractionAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: infractionType["LOADING_INFRACTIONS"], payLoad: true });
    const response = await infractionService.getAnInfraction(id);
    dispatch({ type: infractionType["LOADING_INFRACTIONS"], payLoad: false });
    dispatch({ type: infractionType["SINGLE_INFRACTION"], payLoad: response });
  } catch (error) {
    dispatch({ type: infractionType["LOADING_INFRACTIONS"], payLoad: false });
    errorHandler(error, true);
  }
};

export const updateAnInfractionAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: infractionType["UPDATING"], payLoad: true });
    const response = await infractionService.updateAnInfraction(payLoad);
    dispatch({ type: infractionType["UPDATING"], payLoad: false });
    dispatch({ type: infractionType["UPDATE_INFRACTION"], payLoad: response });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: infractionType["UPDATING"], payLoad: false });
    errorHandler(error, true);
  }
};

/**
 * Get my reward
 **/

// export const getMyRewardsAction = () => async (dispatch) => {
//   try {
//     dispatch({ type: rewardType["LOADING_REWARDS"], payLoad: true });
//     const response = await rewardService.getMyReward();
//     dispatch({ type: rewardType["LOADING_REWARDS"], payLoad: false });
//     dispatch({ type: rewardType["GET_MY_REWARD"], payLoad: response });
//   } catch (error) {
//     dispatch({ type: rewardType["LOADING_REWARDS"], payLoad: false });
//     errorHandler(error, true);
//   }
// };

// export const claimARewardAction = (payLoad) => async (dispatch) => {
//   try {
//     dispatch({ type: rewardType["UPDATING"], payLoad: true });
//     const response = await rewardService.claimAReward(payLoad);
//     console.log("response", response);
//     dispatch({ type: rewardType["UPDATING"], payLoad: false });
//     dispatch({ type: rewardType["CLAIM_REWARD"], payLoad: response });
//     successHandler(response, true);
//     return response;
//   } catch (error) {
//     dispatch({ type: rewardType["UPDATING"], payLoad: false });
//     errorHandler(error, true);
//   }
// };
